module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'form',
        'propertiesForm',
    ],

    config: {
        entityContext: 'schoolVacation',
        preventClearOnCancel: true,
        heartbeatRefreshOn: {
            'reconnect': true,
            'resourceChanged.bosch_schoolVacation': true,
        },
    },
}